import "./App.css";
import { Construction } from "./containers";

function App() {
  return (
    <>
      <Construction />
    </>
  );
}

export default App;
